<template>
  <div class="grid">
    <div class="title">
      <h2 class="t-h1">{{ t('stages') }}</h2>
      <div v-if="stages.length > 3" class="navigation">
        <button
          class="navigation-button navigation-button--prev"
          :aria-label="t('pagination.previous')"
        >
          <ArrowLeftIcon aria-hidden="true" role="img" />
        </button>
        <button
          class="navigation-button navigation-button--next"
          :aria-label="t('pagination.next')"
        >
          <ArrowRightIcon aria-hidden="true" role="img" />
        </button>
      </div>
    </div>
    <div class="slides">
      <Swiper
        :key="$route.query.date?.toString()"
        :navigation="
          stages.length > 3
            ? {
                prevEl: `#widget-${widgetId} .navigation-button--prev`,
                nextEl: `#widget-${widgetId} .navigation-button--next`
              }
            : false
        "
        :slides-per-view="3.17"
        :space-between="20"
        :slides-offset-before="40"
        :slides-offset-after="40"
        :no-swiping="stages.length < 4"
      >
        <SwiperSlide
          v-for="(stage, index) in stages"
          :key="stage.place_id"
          class="slide"
          :swiper-slide-index="index"
        >
          <LineUpHeading>{{ stage.place_name }}</LineUpHeading>
          <div class="events">
            <EventCard
              v-for="event in stage.events"
              :key="event.id"
              :event="event"
              :color="stage.place_color"
              :place="stage.place_name"
            />
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  </div>
</template>

<script lang="ts" setup>
import ArrowLeftIcon from '@/assets/icons/arrow-left.svg'
import ArrowRightIcon from '@/assets/icons/arrow-right.svg'
import { LineUpStage } from '@/service/__generated-api'

defineProps<{
  widgetId: string
  stages: LineUpStage[]
}>()

const { t } = useI18n()
</script>

<style lang="scss" scoped>
.title {
  @include column(lg, 12);
  margin-top: rem(24px);
  margin-bottom: rem(96px);
}

.title {
  display: flex;
  gap: rem(24px);
  align-items: center;
  justify-content: space-between;
}

.navigation {
  display: flex;
  gap: rem(3.23px);
  align-items: center;
}

.navigation-button {
  @include size(rem(42px));
  @include focus-visible;
  display: flex;
}

.slides {
  @include column(lg, all);
}

.events {
  display: flex;
  flex-direction: column;
  gap: rem(16px);
  margin-top: rem(16px);
}
</style>
